import { Spinner } from "reactstrap";

export const PageWrapper = ({ loading, error, children }) => {
  if (loading) return <Spinner style={{ width: "3rem", height: "3rem" }} />;
  if (error) return <div>{error.message}</div>;
  return <>{children}</>;
};
